import React from 'react';
import * as styles from './UpgradeButton.module.scss';
import type { ButtonProps } from '../components/Button';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import boltIcon from '../icons/non-prefilled/16x16/bolt.svg';

type UpgradeButtonProps = {
  size?: ButtonProps['size'];
  variant?: 'secondary' | 'link';
} & Pick<ButtonProps, 'children' | 'onClick' | 'to' | 'disabled'>;

const UpgradeButton = ({
  children,
  size = 'regular',
  onClick,
  to,
  disabled,
  variant = 'secondary',
}: UpgradeButtonProps) => {
  return (
    <div className={styles.upgradeButtonContainer}>
      <Button
        className={styles.upgradeButton}
        size={size}
        icon={
          <SVGIcon
            size={['micro', 'small'].includes(size) ? 'small' : 'regular'}
            className={styles.boltIcon}
          >
            {boltIcon}
          </SVGIcon>
        }
        variant={variant}
        onClick={onClick}
        to={to}
        disabled={disabled}
      >
        {children}
      </Button>
    </div>
  );
};

export default UpgradeButton;
